<template>
<div>
  <transition leave-active-class="duration-200">
    <div v-show="!closed" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-24 text-center sm:block sm:p-0">
        <transition enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
        >
          <div v-if="!closed" class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-grey-dark opacity-75 z-broadcast-message-backdrop"></div>
          </div>
        </transition>
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <transition enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div v-if="!closed"
               class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
               role="dialog"
               aria-modal="true"
               :aria-labelledby="`broadcast-${message.id}-modal-header`"
          >
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button type="button"
                      class="text-primary hover:text-primary-light focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                      aria-label="Закрыть объявление"
                      @click="close"
              >
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="sm:flex sm:items-start">
              <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white sm:mx-0 sm:h-10 sm:w-10">
                <!-- Heroicon name: exclamation -->
                <svg class="h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 v-if="message.header" class="text-lg leading-normal font-medium text-black" :id="`broadcast-${message.id}-modal-header`">
                  {{ message.header }}
                </h3>
                <div class="mt-2">
                  <p class="text-sm leading-normal text-dark" v-html="message.message"></p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <span class="flex flex-col sm:flex-row w-full rounded-md shadow-sm sm:ml-3 sm:w-auto gap-4">
                <button type="button"
                        class="btn btn-rounded btn-sm block w-full sm:inline sm:w-auto order-2 sm:order-1"
                        :class="[hasAction ? 'btn-default' : 'btn-primary']"
                        @click="close"
                >
                  {{ cancelButtonLabel }}
                </button>

                <button v-if="hasAction"
                        type="button"
                        class="order-1 sm:order-2 btn btn-primary btn-rounded btn-sm block w-full sm:inline sm:w-auto"
                        :disabled="actionIsRunning"
                        @click="runAction"
                >
                  <i v-if="actionIsRunning" class="fa fa-spinner-third fa-spin mr-1"></i>
                  {{ actionButtonLabel }}
                </button>
              </span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
export default {
  props: {
    message: {
      required: true,
      type: Object,
    },

    closed: {
      required: true,
      type: Boolean,
    },
  },

  computed: {
    hasAction() {
      return !!this.message?.action
    },

    actionButtonLabel() {
      return this.message?.action.button;
    },

    cancelButtonLabel() {
      if (!this.hasAction) {
        return 'Закрыть сообщение';
      } else if (this.message.action?.cancel) {
        return this.message.action.cancel;
      }

      return 'Закрыть сообщение';
    },
  },

  methods: {
    close() {
      this.$emit('closed')
    },

    async runAction() {
      if (typeof this.message?.action?.handler !== 'function') {
        return false;
      } else if (this.actionIsRunning) {
        return false;
      }

      this.actionIsRunning = true;

      await this.message.action.handler();

      this.actionIsRunning = false;

      this.close();
    },
  },

  data() {
    return {
      actionIsRunning: false,
    };
  },
}
</script>
